import { Mail, User, Users, BookIcon, GraduationCap, Award } from "lucide-react";

const ProfileStatsCard = ({ user, stats, className }) => {
    // Get initials for avatar fallback
    const getInitials = () => {
        return `${user.first_name?.[0] || ""}${user.last_name?.[0] || ""}`.toUpperCase()
    }

    return (<div className={`card bg-base-100 shadow-xl ${className}`}>
        <div className="card-body items-center text-center">
            <div className="avatar mb-4">
                <div className="w-24 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                    {user.avatar_url ? (
                        <img src={user.avatar_url || "/placeholder.svg"} alt={`${user.first_name} ${user.last_name}`} />
                    ) : (
                        <div className="h-full bg-primary text-primary-content flex items-center justify-center text-2xl font-bold">
                            {getInitials()}
                        </div>
                    )}
                </div>
            </div>
            <h2 className="card-title text-2xl">
                {user.first_name} {user.last_name}
            </h2>
            <div className="badge badge-outline mt-1">
                {user.user_type === "admin"
                    ? "Administrator"
                    : user.user_type === "lecturer"
                        ? "Lecturer"
                        : user.user_type === "teacher"
                            ? "Teacher"
                            : "Student"}
            </div>
            <div className="divider my-2"></div>
            <div className="w-full text-left space-y-3">
                <div className="flex items-center gap-2">
                    <Mail className="h-4 w-4 opacity-70" />
                    <span className="text-sm">{user.email}</span>
                </div>
                {user.gender && (
                    <div className="flex items-center gap-2">
                        <User className="h-4 w-4 opacity-70" />
                        <span className="text-sm capitalize">{user.gender.toLowerCase()}</span>
                    </div>
                )}
                {user.department && (
                    <div className="flex items-center gap-2">
                        <Users className="h-4 w-4 opacity-70" />
                        <span className="text-sm">{user.department}</span>
                    </div>
                )}
            </div>
            <div className="divider my-2">Statistics</div>
            <div className="stats stats-vertical shadow w-full">
                <div className="stat">
                    <div className="stat-figure text-primary">
                        <BookIcon className="h-5 w-5" />
                    </div>
                    <div className="stat-title">Total Quizzes</div>
                    <div className="stat-value text-primary">{stats.totalQuizzes}</div>
                    <div className="stat-desc">{stats.completedQuizzes} completed</div>
                </div>
                <div className="stat">
                    <div className="stat-figure text-secondary">
                        <GraduationCap className="h-5 w-5" />
                    </div>
                    <div className="stat-title">Courses</div>
                    <div className="stat-value text-secondary">{stats.totalCourses}</div>
                </div>
                <div className="stat">
                    <div className="stat-figure text-secondary">
                        <Award className="h-5 w-5" />
                    </div>
                    <div className="stat-title">Best Score</div>
                    <div className="stat-value">{stats.bestScore.toFixed(0)}%</div>
                    <div className="stat-desc text-success">Average: {stats.averageScore.toFixed(0)}%</div>
                </div>
            </div>
            <div className="w-full space-y-4 mt-4">
                <div className="space-y-1">
                    <div className="flex justify-between text-sm">
                        <span className="opacity-70">Completion Rate</span>
                        <span className="font-medium">{stats.completionRate.toFixed(1)}%</span>
                    </div>
                    <progress
                        className="progress progress-primary w-full"
                        value={stats.completionRate}
                        max="100"
                    ></progress>
                </div>
            </div>
        </div>
    </div>
    )
};

export default ProfileStatsCard;